// extracted by css-extract-rspack-plugin
var _1 = "_8yG8D2dAS4acyZ3VEy-Daw--";
var _2 = "_31ASFay4VgZrIA4nHAQQgw--";
var _3 = "jXRo-W1yMB8ULTgwa6l1vQ--";
var _4 = "-PMXLUdrI-1Mq2yhAJ6-IQ--";
var _5 = "PxKq4cEb3mNvvjrfYwxu6g--";
export { _1 as "buttons", _2 as "closeIcon", _3 as "icon", _4 as "scaleIn", _5 as "wrapper" }
